var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12517_486955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12517_486955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 20.225L9.05 18.825C7.18333 17.1417 5.54167 15.5068 4.125 13.9203C2.70833 12.3338 2 10.5854 2 8.675C2 7.10833 2.53077 5.79167 3.5923 4.725C4.65385 3.65833 5.97657 3.125 7.56045 3.125C8.45348 3.125 9.28333 3.3125 10.05 3.6875C10.8167 4.0625 11.4667 4.54167 12 5.125C12.5167 4.54167 13.1583 4.0625 13.925 3.6875C14.6917 3.3125 15.5231 3.125 16.4194 3.125C18.009 3.125 19.3365 3.65833 20.4019 4.725C21.4673 5.79167 22 7.10833 22 8.675C22 10.5917 21.2792 12.35 19.8375 13.95C18.3958 15.55 16.6917 17.2417 14.725 19.025L13.4 20.225C13 20.5917 12.5333 20.7708 12 20.7625C11.4667 20.7542 11 20.575 10.6 20.225ZM11 7.15C10.7167 6.68333 10.2625 6.24583 9.6375 5.8375C9.0125 5.42917 8.31667 5.225 7.55 5.225C6.55 5.225 5.725 5.55 5.075 6.2C4.425 6.85 4.1 7.675 4.1 8.675C4.1 9.54167 4.40485 10.4518 5.01455 11.4053C5.62425 12.3588 6.35342 13.2838 7.20205 14.1803C8.05068 15.0768 8.92083 15.9125 9.8125 16.6875C10.7042 17.4625 11.4333 18.1167 12 18.65C12.55 18.15 13.2727 17.5039 14.1682 16.7117C15.0637 15.9194 15.9345 15.0694 16.7807 14.1617C17.6269 13.2539 18.3583 12.324 18.975 11.3721C19.5917 10.4202 19.9 9.52115 19.9 8.675C19.9 7.675 19.5702 6.85 18.9107 6.2C18.2512 5.55 17.4267 5.225 16.4374 5.225C15.6625 5.225 14.975 5.42917 14.375 5.8375C13.775 6.24583 13.325 6.68333 13.025 7.15C12.9083 7.33333 12.7586 7.475 12.5758 7.575C12.393 7.675 12.2011 7.725 12 7.725C11.8167 7.725 11.6333 7.675 11.45 7.575C11.2667 7.475 11.1167 7.33333 11 7.15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearth);
export default __webpack_public_path__ + "static/media/hearth.39b5fa341092c0a86ae9deb19dde5ab7.svg";
export { ForwardRef as ReactComponent };